<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-8 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <div class="text-justify intro-text">
                  <span class="sp-danger">اگر پلاک ماشینی جهت کشف حجاب ثبت شود، چه اتفاقی می افتد؟</span><br><br>
                  <span class="bold-h">مرحله اول</span><br><br>
                  <span> ثبت پلاک برای اولین مرتبه: </span><br>
                  <span> پس از ثبت پلاک  توسط شما در سامانه، در صورتی که اولین مرتبه ای  است که برای صاحب ماشین ثبت تخلف کشف حجاب </span><br>
                  <span> ثبت میگردد،  عنوان (وضعیت تخلف: تذکر) در خط آخر، در قسمت ( گزارش ثبت تخلفات قبلی)  در سامانه ثبت می گردد: </span><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/info3.jpg"  alt="img" class="img-fluid col-6"/></div>
                  <br><br><span> و پیامک زیر برای صاحب خودرو میرود: </span><br>
                  <span> مالک محترم خودروی شماره ...........................   در خودروی شما  در آدرس شهرتهران، بزرگراه امام علی ع به سمت جنوب </span><br>
                  <span> در تاریخ ........................... عدم رعایت حقوق شهروندی (کشف حجاب) صورت گرفته است.ضمن در خواست وتاکید بر </span><br>
                  <span> رعایت هنجارهای جامعه ضروریست بر عدم تکرار آن اهتمام ورزید.بدیهی است در صورت تکرارآن پیگیری انتظامی وقضایی اعمال  </span><br>
                  <span> خواهد شد. </span><br><br><br><br>
                  <span class="bold-h">مرحله دوم</span><br>
                  <span>  ثبت پلاک برای دومین مرتبه:  </span><br>
                  <span> در صورتی که پس از مدتی، <span class="text-danger">کاربر</span> دیگری همان پلاک را به خاطر کشف حجاب، برای دومین بار در همان روز و یا روز دیگری  ثبت  </span><br>
                  <span> کند، چند ثانیه بعد از ثبت پلاک، پیامکی مبنی بر احضار صاحب ماشین به نزدیکترین مرکز امنیت اخلاقی جهت اخذ تعهد و باز   </span><br>
                  <span> شدن پرونده در نیروی انتظامی ارسال میگردد.  </span><br>
                  <span> پس از ثبت پلاک در این حالت، عنوان (وضعیت تخلف: اخطار 1) در خط آخر در قسمت( گزارش ثبت تخلفات قبلی)  در سامانه  </span><br>
                  <span> ثبت می گردد:  </span><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/info4.jpg"  alt="img" class="img-fluid col-6"/></div>
                  <span> نکته:  </span><br>
                  <span> حال در این حالت، در صورتی که شخص به یک مرکز امنیت اخلاقی مراجعه کند، از وی تعهد گرفته میشود.  </span><br>
                  <span>  در این حالت، وضعیت تخلف آن پلاک از حالت(اخطار1) به (اخذ تعهد) تغییر پیدا میکند.  </span><br>
                  <span> حالا اگر صاحب ماشین به پلیس امنیت اخلاقی جهت دادن تعهد مراجعه نکند، پس از مدت حدود 20 روز، وضعیت تخلف آن  </span><br>
                  <span> پلاک از حالت <span class="text-danger">اخطار1</span> به  <span class="text-danger">اخطار2 توقیف</span> بر اثر دیرکرد تبدیل میگردد.  </span><br><br><br><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/info5.jpg"  alt="img" class="img-fluid col-6"/></div><br>
                  <span> توقیف ماشین هم که وضعیتش مشخص است. یعنی به کل نیروهای انتظامی کشور اعلام میگردد، این ماشین با این پلاک در هر   </span><br>
                  <span> جایی از کشور دیده شد بایستی  توقیف گردد تا مشکلش در آن اداره تا مرکزی که اعلام شده حل گردد.  </span><br><br><br><br>
                  <span class="bold-h">مرحله سوم</span><br><br>
                  <span> ثبت پلاک برای سومین مرتبه:  </span><br>
                  <span> در صورتی که پلاک مد نظر، توسط کاربر دیگری برای سومین مرتبه ثبت کشف حجاب شود، ضمن اینکه برای صاحب ماشین،  </span><br>
                  <span> پرونده ای در نیروی انتظامی باز میشود، حکم توقیف ماشین به صاحب ماشین اعلام و توقیف به کلیه مراکز نیروی انتظامی سراسر   </span><br>
                  <span> کشور اعلام میگردد و درعمل، پس ازآن تا یک هفته توقیف می گردد،   </span><br><br><br>
                  <span> حال و پس از اطلاع از این نرم افزار، اگر مایل به  ثبت نام در این سامانه هستید، ادامه مطالب در صفحه بعد.  </span><br><br>
                </div>

                <RouterLink to="/introThird" class="bbot mx-auto">
                  ▶ صفحه قبل
                </RouterLink>
                <RouterLink to="/register" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.intro-text{
  font-family: Calibri,sans-serif;
}
</style>
<script>
/*import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}*/

</script>
